// extracted by mini-css-extract-plugin
export default {"content":"crete-coupon_content__N0Vhi","couponContainer":"crete-coupon_couponContainer__CwJhF","notification":"crete-coupon_notification__Vpe5a","shown":"crete-coupon_shown__h8kjP"};